import styled, { css } from "styled-components"
import Breakpoints from "./breakpoints"
import { FontFamilyRegular } from "./typography.styles"

export const OverlayStyle = css`
  background-color: #282828;
  mix-blend-mode: multiply;
`

export const StatListItem = styled.li`
  color: var(--white);
  ${FontFamilyRegular}
  font-style: normal;
  text-transform: uppercase;
  text-align: center;

  font-weight: 400;
  letter-spacing: 0.08em;

  font-size: 10px;
  line-height: 10px;

  display: flex;
  align-items: baseline;

  white-space: nowrap;

  &:nth-child(2) {
    align-self: flex-end;
    margin: 16px 0;
  }

  @media (min-width: ${Breakpoints.md}) {
    margin: 24px 0;
    flex-direction: column;
    align-items: unset;
    &:nth-child(2) {
      align-self: unset;
      margin: 0;
    }
  }

  @media (min-width: ${Breakpoints.lg}) {
    font-weight: 300;
    margin: 32px 0;
    font-size: 14px;
    line-height: 13px;
  }
`
export const StatListSmall = styled.span`
  font-size: 30px;
  margin-left: 5px;
  line-height: 0px;

  @media (min-width: ${Breakpoints.md}) {
    font-size: 16px;
    font-weight: 400;
  }
  @media (min-width: ${Breakpoints.lg}) {
    font-size: 30px;
  }
`

export const StatListNumber = styled.span`
  display: inline-flex;
  align-items: baseline;
  font-size: 30px;
  line-height: 29px;
  max-height: 48px;
  margin: 0 12px 0 0;

  @media (min-width: ${Breakpoints.md}) {
    margin: 0 0 8px 0;
    align-self: center;
  }
  @media (min-width: ${Breakpoints.lg}) {
    font-size: 48px;
    line-height: 46px;
  }
`

export const StatListContainer = styled.ul`
  width: 100%;
  grid-column: 2 / -2;
  display: flex;
  flex-direction: column;
  padding: 32px 0;

  @media (min-width: ${Breakpoints.md}) {
    grid-column: 2 / -2;
    flex-direction: row;
    justify-content: space-around;
    padding: 0;
    align-items: center;
  }

  @media (min-width: ${Breakpoints.lg}) {
    grid-column: 3 / -3;
  }
`

export const StatListPlus = styled.span`
  font-size: 30px;
  line-height: 29px;
  margin-left: 5px;
  align-self: center;

  @media (min-width: ${Breakpoints.md}) {
    font-size: 16px;
    font-weight: 400;
  }
  @media (min-width: ${Breakpoints.lg}) {
    font-size: 30px;
  }
`
